module.exports = __webpack_public_path__ + "img/sld_scb_13_t1_b1.e8fcc8bb.svg";